// Hooks / Node modules / Styles
import { Footer } from "elseware-ui";

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components
import PlatformsGroup from "../platforms-group/PlatformsGroup";
import FooterLink from "./components/FooterLink";
import FooterLinkGroup from "./components/FooterLinkGroup";
import CustomBrand from "../custom-brand/CustomBrand";

// Data / Images / Icons
import SOCIAL_MEDIA_NAV from "../../../data/nav/social_media_nav";

const RESOURCES_DATA = {
  title: "Resources",
  links: [
    {
      name: "Online Services",
      path: "/",
    },
    {
      name: "Support",
      path: "/",
    },
    {
      name: "EULA",
      path: "/",
    },
  ],
};

const GAMES_DATA = {
  title: "elseware Technology",
  links: [
    {
      name: "Rise of Rage",
      path: "/",
    },
    {
      name: "Geeka",
      path: "/",
    },
    {
      name: "Micro Hunt",
      path: "/",
    },
  ],
};

function CustomFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <Footer styles="bg-primary-500 border-t border-dark-500/40 dark:border-secondary-500/40 theme-bg-md py-16 px-5 lg:px-[150px]">
      {/* Footer links */}
      <div className="py-1 flex flex-row items-center justify-between ">
        <PlatformsGroup data={SOCIAL_MEDIA_NAV} />
        <CustomBrand />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3">
        <FooterLinkGroup data={RESOURCES_DATA} />
        <FooterLinkGroup data={GAMES_DATA} />
        <FooterLinkGroup data={GAMES_DATA} />
      </div>

      <div className="mt-3 border-t border-t-gray-700">
        <div className="text-gray-500 text-sm md:max-w-[600px] py-5">
          © {currentYear}, elseware Technology, Inc. All rights reserved.
          elseware, elseware Technology and the elseware Technology logo are
          trademarks or registered trademarks of elseware Technology, Inc. in
          the Sri Lanka and elsewhere. Other brands or product names are the
          trademarks of their respective owners.
        </div>
        <div className="flex flex-wrap gap-10">
          <FooterLink name="Terms of Service" to="/terms-of-service" />
          <FooterLink name="Privacy Policy" to="/privacy-policy" />
          <FooterLink name="Store Refund Policy" to="/" />
        </div>
      </div>
    </Footer>
  );
}

export default CustomFooter;
